import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { setBadge } from "@/lib/push";

const empty = { total: 0, tasks_total: 0, bookings_total: 0, chat_total: 0, chat_flame: 0, tasks: {}, bookings: {}, chat: {}, chat_flame_map: {} };
const Ctx = createContext({ data: empty, refresh: () => {} });

export const useNotifications = () => useContext(Ctx);

export function NotificationsProvider({ children }) {
  const [data, setData] = useState(empty);

  const refresh = useCallback(() => {
    api.get("/notifications").then(({ data }) => { setData(data); setBadge((data.total || 0) + (data.chat_total || 0) + (data.reservations_pending || 0)); }).catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 30000);
    const onFocus = () => refresh();
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(id); window.removeEventListener("focus", onFocus); };
  }, [refresh]);

  return <Ctx.Provider value={{ data, refresh }}>{children}</Ctx.Provider>;
}
